import _ from 'lodash';
import {
  fork,
  call,
  select,
  put,
  takeLatest
} from 'redux-saga/effects';
import {
  navigationRoutes,
  navigationSteps
} from '../../navigation/navigationHelpers';
import loader from '../../../../util/loader/loader';
import {
  HANDLE_ERROR,
  HANDLE_INTERACTION
} from './error';
import {
  setContactUsError,
  commonErrorsSelector,
  SET_ERROR
} from '../../common/common';

export function* handleErrorWatch() {
  yield takeLatest(HANDLE_ERROR, handleErrorWorker);
}

export function* handleContactUsWatch() {
  yield takeLatest(HANDLE_INTERACTION, handleContactUsWorker);
}

export function* setErrorWatch() {
  yield takeLatest(SET_ERROR, setErrorWorker);
}

export function* handleErrorWorker({content, errorType, endpointUrl} = {}) {

  // log exception on the server
  const error = JSON.parse(JSON.stringify(content, ["message", "arguments", "type", "name", "stack", "error", "status", "data", "statusText"]));
  const pageUrl = _.get(window, 'location.href');
  const data = {error, errorType, endpointUrl, pageUrl};
  const endpoint = navigationRoutes[navigationSteps.myPlan.ERROR].endpoints.logErrors();

  try {
    yield fork(loader.request, endpoint,
      {
        data,
        redirectOnError: false,
        fetchContextIfNotFetched: false,
        useGlobalSpinner: false,
        showPageLevelError: false
      });
  } catch(e) {
    //
  }
}

export function* handleContactUsWorker() {
  const endpoint = navigationRoutes[navigationSteps.quickCheckout.CONTACTUS].endpoints.userInteraction();
  const toUrl = _.get(window, 'location.href');
  const data = {toUrl};

  yield call(loader.request, endpoint, {
    data,
    redirectOnError: false,
    useGlobalSpinner: false
  });
}

export function* setErrorWorker() {
  try {
    const errors = yield select(commonErrorsSelector);
    const contactUsErrorCode = errors ? errors.filter(error => error.errorCode.indexOf('DFPLN') > -1) : [];

    if (contactUsErrorCode) {
      yield put(setContactUsError(contactUsErrorCode[0].errorCode));
    }
  } catch(e) {
    //
  }
}

export default function* errorSagas() {
  yield [
    fork(handleErrorWatch),
    fork(handleContactUsWatch),
    fork(setErrorWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/error/errorSagas.js
 **/